import { render, staticRenderFns } from "./store-nav.vue?vue&type=template&id=efab99da&scoped=true&"
import script from "./store-nav.vue?vue&type=script&lang=js&"
export * from "./store-nav.vue?vue&type=script&lang=js&"
import style0 from "./store-nav.vue?vue&type=style&index=0&id=efab99da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efab99da",
  null
  
)

export default component.exports